import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import { Icon } from 'loyal-react'
import { CatalogCurrencyLabel } from 'Shared/CurrencyLabel'

const ShippingCalculed = props => {
  return (
    <div className='shippingCalculated col-12 col-md'>
      <div className='row align-items-center h-100'>
        <div className='col-12 col-md my-1 my-md-0'>

          { !props.isLoading ? (
            <Fragment>
              <p className='txt-subtitle'>{props.address.zipCode}</p>
              <p
                className={`txt-subtitle ${
                  props.shipping.error_get_shipping || props.shipping.error
                    ? 'txt-uppercase txt-circular-black color-error'
                    : ''
                }`}
              >
                {!props.shipping.error_get_shipping && !props.shipping.error
                  ? ((props.address.streetType &&
                    props.address.streetType + ' ') ||
                    '') +
                    ((props.address.street && props.address.street + ' - ') ||
                      '') +
                    ((props.address.district &&
                      props.address.district + ' - ') ||
                      '') +
                    ((props.address.city && props.address.city + ' - ') || '') +
                    props.address.state || ''
                  : 'Não é possível entregar no CEP digitado.'}
              </p>
            </Fragment>
          ) : <div role='status' aria-live='assertive' aria-atomic='true'>
            <Icon iconName='icon_loading' className='color-brand-4 icon' />
            <span className='hide-absolute'>Carregando...</span>
          </div>}
        </div>
        <div className='col-12 col-md-3 pl-half'>
          { !props.isLoading ? (
            <Fragment>
              <p className='txt-uppercase txt-circular-black txt-body txt-left color-brand-1'>
                {props.shipping.error_get_shipping || props.shipping.error ? (
                  ''
                ) : (
                  <CatalogCurrencyLabel
                    price={{
                      points: props.shipping.total,
                      cash: props.shipping.totalCash
                    }}
                    checkCashOnly
                  />
                )}
              </p></Fragment>
          ) : <div>
            <Icon iconName='icon_loading' className='color-brand-4 icon' />
            <span className='hide-absolute'>Carregando...</span>
          </div>}
        </div>
      </div>
    </div>
  )
}

ShippingCalculed.propTypes = {
  address: PropTypes.shape({
    zipCode: PropTypes.string.isRequired,
    cepError: PropTypes.string.isRequired,
    streetType: PropTypes.string.isRequired,
    street: PropTypes.string.isRequired,
    district: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired
  }),
  shipping: PropTypes.shape({
    total: PropTypes.number.isRequired,
    totalCash: PropTypes.number.isRequired,
    error: PropTypes.bool,
    error_get_shipping: PropTypes.bool
  }),
  isLoading: PropTypes.bool.isRequired
}

export default ShippingCalculed



// WEBPACK FOOTER //
// ./src/features/Cart/List/ShippingCalculator/ShippingCalculed/ShippingCalculed.js